/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_ValueInputs */

const en_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom Value`)
};

const fr_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur du zoom`)
};

const de_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoomwert`)
};

const it_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore di zoom`)
};

const ru_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значение масштабирования`)
};

const es_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor de zoom`)
};

const zh_cn2_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩放值`)
};

const ja_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズーム値`)
};

const hi_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम वैल्यू`)
};

const pt_pt2_zoom_value = /** @type {(inputs: Zoom_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor do zoom`)
};

/**
* | output |
* | --- |
* | "Zoom Value" |
*
* @param {Zoom_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_value = /** @type {((inputs?: Zoom_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_zoom_value(inputs)
	if (locale === "de") return de_zoom_value(inputs)
	if (locale === "it") return it_zoom_value(inputs)
	if (locale === "ru") return ru_zoom_value(inputs)
	if (locale === "es") return es_zoom_value(inputs)
	if (locale === "zh-CN") return zh_cn2_zoom_value(inputs)
	if (locale === "ja") return ja_zoom_value(inputs)
	if (locale === "hi") return hi_zoom_value(inputs)
	if (locale === "pt-PT") return pt_pt2_zoom_value(inputs)
	return en_zoom_value(inputs)
});